import React from 'react';
import { Button, Modal, Form, InputGroup, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PlusIconWhite, SearchIcon } from '../ui/icons';
import TreeView from '../treeView';
import { useInviteUser } from './useInviteUser';
import { roleIds } from '../../config';
import InformationCircle from '../../assets/images/info-circle.svg'

const InviteUserModal: React.FC<{}> = () => {
  const {
    groupSearchQuery,
    email,
    role,
    nodesToDisplay,
    show,
    name,
    isPasswordEnable,
    handleGroupInputChange,
    handleDataFromTreeView,
    setIsEmptyGroupShown,
    setSearchTerm,
    setEmail,
    setRole,
    handleShow,
    handleClose,
    handleOnSubmit,
    setName,
    setIsPasswordEnable,
    emailError,
    handleEmailChange
  } = useInviteUser();

  return (
    <>
      <Button variant='primary' onClick={handleShow}>
        <PlusIconWhite />
        <span>Invite User</span>
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        className='modal-container assign-roles-modal'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Assign Roles</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleOnSubmit}>
          <Modal.Body>
            <div className='assign-roles-container'>
              <Row>
                <Col sm={6}>
                  <div className='assign-roles-input'>
                    <Form.Group className='mb-3' controlId='createUserEmail'>
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        required
                        type='email'
                        placeholder='example@email.com'
                        value={email}
                        onChange={handleEmailChange}
                      />
                      {emailError && <p style={{ color: 'red' }}>{emailError}</p>}  
                    </Form.Group>
                  </div>

                  <div className='assign-roles-input'>
                    <Form.Group className='mb-3' controlId='createUserName'>
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        required
                        type='text'
                        placeholder='Enter user name'
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Form.Group>
                  </div>
                  
                  <div className="org-user-checkbox mb-3">
                    <Form.Label htmlFor="enablePassword">
                      Sign-In Preference{' '}
                      {!isPasswordEnable && (
                        <OverlayTrigger
                          placement='right'
                          overlay={
                            <Tooltip id='password-disabled-tooltip'>
                              Use a valid Google or Microsoft email—both personal and work accounts are supported.
                            </Tooltip>
                          }
                        >
                          <span style={{ cursor: 'pointer', marginLeft: '5px', color: '#0d6efd' }}>
                            <img src={InformationCircle} alt="Info" width={18} height={18}/>
                          </span>
                        </OverlayTrigger>
                      )}
                    </Form.Label>
                    <div className="checkbox">
                      <Form.Check
                        inline
                        type="radio"
                        label="Google/Microsoft"
                        name="enablePassword"
                        onChange={() => {
                          setIsPasswordEnable(false);
                        }}
                        checked={!isPasswordEnable}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        label="Email & Password"
                        id="organizationuserEnablePassword"
                        aria-describedby="organizationuserEnablePassword"
                        name="enablePassword"
                        onChange={() => setIsPasswordEnable(true)}
                        checked={isPasswordEnable}
                      />
                    </div>
                  </div>
                  <div className='assign-roles-select'>
                    <Form.Label>Choose Role Type</Form.Label>
                    <Form.Select
                      aria-label='Choose Role Type'
                      onChange={(e) => setRole(e.target.value)}
                      value={role}
                      required
                    >
                      <option value=''>Select Role</option>
                      <option value={roleIds.admin}>Admin</option>
                      <option value={roleIds.operator}>Operator</option>
                      <option value={roleIds.viewer}>Viewer</option>
                    </Form.Select>
                  </div>
                </Col>
                <Col sm={1}>
                  <div className='line'></div>
                </Col>
                <Col sm={5}>
                  <div className='assign-roles-tree-container'>
                    <div className='assign-roles-search'>
                      <InputGroup>
                        <Form.Control
                          placeholder='Search'
                          aria-label='Search'
                          aria-describedby='search-tree-list'
                          value={groupSearchQuery}
                          onChange={handleGroupInputChange}
                        />
                        <InputGroup.Text id='search-tree-list'>
                          <SearchIcon />
                        </InputGroup.Text>
                      </InputGroup>
                    </div>
                    <div className='assign-roles-tree'>
                      <TreeView
                        setIsEmptyGroupShown={setIsEmptyGroupShown}
                        setSearchTerm={setSearchTerm}
                        nodes={nodesToDisplay}
                        onDataFromTreeView={handleDataFromTreeView}
                        isModalOrg={true}
                      ></TreeView>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className='button-bg-white' onClick={handleClose}>
              Cancel
            </Button>
            <Button className='button-bg-blue' type='submit'>
              Invite
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default InviteUserModal;